import Drawer from "@mui/material/Drawer";
import { styled } from "@mui/material/styles";

import { getFormatMedia } from "~/theme/utils";

import { SEARCH_PANEL_MOBILE_CLASSES } from "./constants";

export const SearchPanelMobileContainer = styled(Drawer)(({ theme }) => {
  const formatMedia = getFormatMedia(theme);
  return {
    "&.MuiDrawer-root": {
      [formatMedia.BREAKPOINT_DESKTOP]: {
        display: "none",
      },
    },
    [`& .${SEARCH_PANEL_MOBILE_CLASSES.drawer}`]: {
      width: "100%",
      height: "100%",
    },
    [`& .${SEARCH_PANEL_MOBILE_CLASSES.toolbar} > * :not(:last-of-type)`]: {
      marginRight: theme.spacing(0.5),
    },
  };
});

export const SearchPanelMobilePopover = styled("div")(({ theme }) => {
  const formatMedia = getFormatMedia(theme);

  return {
    backgroundColor: theme.palette.background.paper,
    border: 0,
    display: "none",
    height: "100dvh",
    inset: 0,
    margin: 0,
    maxHeight: "none",
    maxWidth: "none",
    overflow: "auto",
    overscrollBehavior: "contain",
    padding: 0,
    width: "100%",

    "&:popover-open": {
      animation: "mobileSearchPopoverEnter 225ms cubic-bezier(0, 0, 0.2, 1)",
      display: "block",
    },

    "&::backdrop": {
      backgroundColor: "rgba(0, 0, 0, 0.5)",
    },

    [`& .${SEARCH_PANEL_MOBILE_CLASSES.toolbar} > * :not(:last-of-type)`]: {
      marginRight: theme.spacing(0.5),
    },

    [formatMedia.BREAKPOINT_DESKTOP]: {
      display: "none",
    },

    "@keyframes mobileSearchPopoverEnter": {
      from: {
        transform: "translateX(100%)",
      },
      to: {
        transform: "translateX(0)",
      },
    },

    "@media (prefers-reduced-motion: reduce)": {
      "&:popover-open": {
        animation: "none",
      },
    },
  };
});
